import { render, staticRenderFns } from "./PrivacyComp.vue?vue&type=template&id=ec0d726e"
import script from "./PrivacyComp.vue?vue&type=script&lang=js"
export * from "./PrivacyComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports